module.exports = __webpack_public_path__ + "img/present_open.14bf4942.png";